import { useCallback } from 'react';
import { useToast } from './useToast';

export interface Notification {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

export const useNotification = () => {
  const { addToast, toasts, removeToast } = useToast();

  const notify = useCallback(
    (
      message: string,
      options: { type?: Notification['type']; duration?: number } = {}
    ) => {
      addToast(message, {
        type: options.type || 'info',
        duration: options.duration || 5000,
      });
    },
    [addToast]
  );

  const removeNotification = useCallback((notification: Notification) => {
    // Find and remove the toast by message and type
    const toastToRemove = toasts.find(
      (toast) => toast.message === notification.message && toast.type === notification.type
    );
    if (toastToRemove) {
      removeToast(toastToRemove.id);
    }
  }, [toasts, removeToast]);

  return {
    notify,
    notifications: toasts,
    removeNotification,
  };
};
